import React, { useState } from "react";
import { galleryData } from "../Data";

export const Gallery = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openModal = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const showPrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + galleryData.length) % galleryData.length
    );
  };

  const showNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % galleryData.length);
  };

  return (
    <>
      {/* Minimal Header */}
      <div className="bg-slate-900 text-white py-12 md:py-16 text-center">
        <h1 className="text-2xl md:text-4xl font-extralight tracking-widest uppercase text-slate-100">
          Our Gallery
        </h1>
        <div className="w-16 h-0.5 bg-blue-500 mx-auto mt-3 mb-3"></div>
        <p className="text-slate-400 text-xs md:text-sm max-w-xl mx-auto px-4 font-light leading-relaxed">
          A glimpse into our third-party safety inspections and field work.
        </p>
      </div>
      <div className="max-w-screen-xl mx-auto px-4 py-12 bg-gray-50">
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 gap-8 justify-center items-center">
          {galleryData.map((client, index) => (
            <div key={client.id} className="cursor-pointer">
              <img
                src={client.imageSrc}
                alt={client.name}
                onClick={() => openModal(index)}
                className="object-cover w-full max-w-[500px] h-[300px] border-2 border-blue-200 rounded-xl shadow-md hover:scale-105 hover:shadow-xl transition-all mx-auto"
              />
            </div>
          ))}
        </div>


        {isOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
            <div className="relative bg-gray-100 p-6 rounded-lg shadow-2xl max-w-3xl w-full mx-4">
              <button
                onClick={closeModal}
                className="absolute top-2 right-3 text-gray-700 hover:text-red-500 text-2xl font-bold"
              >
                &times;
              </button>

              <img
                src={galleryData[currentIndex].imageSrc}
                alt={galleryData[currentIndex].name}
                className="mx-auto object-contain w-[90vw] max-w-[600px] h-[400px]"
              />

              <button
                onClick={showPrev}
                className="absolute left-2 top-1/2 transform -translate-y-1/2 text-3xl text-gray-600 hover:text-black"
              >
                &#10094;
              </button>
              <button
                onClick={showNext}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-3xl text-gray-600 hover:text-black"
              >
                &#10095;
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
